/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_PainInputs */

const en_us2_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain and injuries`)
};

const pt_br2_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores e lesões`)
};

const es_419_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolores y lesiones`)
};

const pt_pt2_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores e lesões`)
};

const fr_fr2_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleurs et blessures`)
};

const de_de2_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerzen und Verletzungen`)
};

const it_it2_search_field_pain = /** @type {(inputs: Search_Field_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolori e infortuni`)
};

/**
* | output |
* | --- |
* | "Pain and injuries" |
*
* @param {Search_Field_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_pain = /** @type {((inputs?: Search_Field_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_pain(inputs)
	if (locale === "es-419") return es_419_search_field_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_pain(inputs)
	if (locale === "de-DE") return de_de2_search_field_pain(inputs)
	if (locale === "it-IT") return it_it2_search_field_pain(inputs)
	return en_us2_search_field_pain(inputs)
});
export { search_field_pain as "search.field_pain" }